import { useEffect, useState } from 'react';

/**
 * useIsMobile — true when the viewport is at or below the sbr mobile breakpoint
 * (899px, the same width where the app shell switches to the bottom-nav layout).
 * Used by the job drawer to swap its two-column desktop layout for the mobile wizard.
 */
const QUERY = '(max-width:899px)';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false
    );

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mql = window.matchMedia(QUERY);
        const onChange = (e) => setIsMobile(e.matches);
        // addEventListener is the modern API; addListener is the Safari < 14 fallback
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else mql.addListener(onChange);
        setIsMobile(mql.matches);
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange);
            else mql.removeListener(onChange);
        };
    }, []);

    return isMobile;
};

export default useIsMobile;
